import role from "~/resources/users/roles";

export default () => {
  function hasPerm(user, permissions) {
    user = toValue(user);
    if (!permissions || !permissions?.length) {
      return true;
    }
    if (!user) {
      return false;
    }
    // check if all permissions are satisfied...
    if (Array.isArray(permissions)) {
      // ...either they are many...
      return permissions.every((p) => user.permissions.includes(p));
    }
    // or just one
    return user.permissions.includes(permissions);
  }
  const hasRole = (user, roles) => {
    if (!user) {
      return false;
    }
    if (!roles?.length) {
      return true;
    }
    user = toValue(user);
    if (user.is_superuser) {
      return true;
    }
    return roles.map((r) => r.value).includes(user.role);
  };

  const authUser = useState("userv2", () => {
    const user = localStorage.getItem("userv2");
    if (user) {
      return JSON.parse(user);
    }
  });

  const login = async ({ email, password }) => {
    const config = useRuntimeConfig();
    const body = new FormData();
    body.append("username", email);
    body.append("password", password);
    const reqURL = new URL("/webauth/setcsrf/", config.public.baseURL);
    await $fetch(reqURL.href, {
      credentials: "include",
    });
    await useApi(`/webauth/login/`, {
      method: "post",
      redirect: "manual",
      body,
    });
    authUser.value = await useApi("/auth/users/me/");
    localStorage.setItem("userv2", JSON.stringify(authUser.value));
  };

  const logout = () => {
    useApi("/webauth/logout/", {
      method: "post",
    }).then(() => {
      localStorage.removeItem("userv2");
      return navigateTo("/login/");
    });
  };
  // TODO: change this to a basic Django permission
  const hasHoldingsPerm = computed(() => {
    if (hasRole(authUser, [role.ADMINISTRATOR, role.CALL_CENTER_TEAM_LEADER])) {
      return true;
    } else if (hasRole(authUser, [role.CALL_CENTER_OPERATOR])) {
      return authUser.value?.call_center_operator?.enable_holding_shipments;
    }
    return false;
  });

  return {
    role,
    login,
    logout,
    authUser,
    hasRole,
    hasPerm,
    hasHoldingsPerm,
  };
};
